import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@material-ui/core";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import ActionTypes from "../../../../actions/types";
import ArrowSlider from "../../../../components/ArrowSlider";
import HolderModal from "../../../../components/Modals/Holders Modal";
import OIMODAL from "../../../../components/Modals/OI Modal";
import OIWebTable from "./OITable";
import OIStyle from "../../index.module.css";
import BarChartIcon from "@material-ui/icons/BarChart";

const OIMobileViewTable = ({
  styles,
  tableRef,
  props,
  closeOIModal,
  lengthCheck,
  selectDate,
  makeModelRowData,
  handleType,
  openChart,
}) => {
  const state = useSelector((state) => state.OpenInterestState);
  const appReducer = useSelector((state) => state.appReducer);

  const dispatch = useDispatch();
  const setStateAction = (newState) =>
    dispatch({
      type: ActionTypes.SET_OPEN_INTREST,
      payload: newState,
    });
  return (
    <div
      ref={tableRef}
      style={{
        height: "calc(100% - 150px)",
        width: "95%",
        // margin: 'auto',
        overflowY: "scroll",
        position: "absolute",
        top: "260px",
        left: "0px",
      }}
    >
      <div style={styles.tablediv}>
        <div
          style={{
            position: "sticky",
            zIndex: 4,
            left: "0px",
            display: "table",
            height: "100%",
          }}
        >
          <div
            style={{
              ...styles.currentPriceArrowsContainer,
              width: "55px",
            }}
          >
            <ArrowSlider
              height={0}
              arrowPos={0}
              yStartingPosition={state.arrowPosition}
              rowHeight={30}
              strikeArrow
              basicStrike
              isMobile={appReducer.isMobile}
              side={"left"}
            />
            <ArrowSlider
              height={0}
              arrowPos={0}
              yStartingPosition={state.arrowPosition}
              rowHeight={30}
              strikeArrow
              basicStrike
              isMobile={appReducer.isMobile}
              side={"right"}
            />
          </div>
          <div style={{ ...styles.stCell }}>
            {state.type === "calls" && (
              <div
                onClick={() => handleType()}
                style={{
                  ...styles.callbtn,
                  width: "45px",
                }}
                className={OIStyle.OICallContainer}
              >
                C
              </div>
            )}
            {state.type === "puts" && (
              <div
                onClick={() => handleType()}
                style={{
                  ...styles.putbtn,
                  width: "45px",
                }}
                className={OIStyle.OICallContainer}
              >
                P
              </div>
            )}
            <BarChartIcon
              onClick={() => openChart()}
              style={{
                color: "white",
                width: "50%!important",
                paddingTop: "3px",
              }}
              height={50}
              width={50}
            />
          </div>

          <Table stickyHeader className={OIStyle.OITableCustomization}>
            <TableHead>
              {props.OIStrikes.length > 0 && (
                <TableRow style={{ height: "31.5px" }}>
                  <TableCell style={styles.headercellstMobile}></TableCell>
                </TableRow>
              )}
            </TableHead>
            <TableBody>
              {props.OIStrikes.map((row, rowindex) => (
                <TableRow key={rowindex} style={{ height: "30px" }}>
                  <TableCell style={styles.strikecell}>
                    {parseFloat(row).toFixed(2)}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>

        <div className={OIStyle.OITableWrapper}>
          {state.isOIchecked ? (
            <OIMODAL
              accessLevel={props.accessLevel}
              showModal={state.isOIchecked}
              ticker={state.localTicker}
              expiration={state.expiration}
              modalRowData={state.modalRowData}
              closeOIModal={closeOIModal}
              selectedDate={state.selectedDate}
            />
          ) : (
            ""
          )}
          {state.holderModal && lengthCheck && (
            <HolderModal
              accessLevel={props.accessLevel}
              isMobile={appReducer.isMobile}
              holderList={appReducer.holderList}
              showModal={state.holderModal}
              setShowModal={() => setStateAction({ holderModal: false })}
              symbol={state.localTicker}
            />
          )}
          <OIWebTable
            styles={styles}
            selectDate={(row) => selectDate(row)}
            makeModelRowData={async (row, cell, dates, cellindex) => {
              makeModelRowData(row, cell, dates, cellindex);
            }}
          />
        </div>
      </div>
    </div>
  );
};
export default OIMobileViewTable;



// WEBPACK FOOTER //
// ./src/Pages/OpenInterest/components/webViewComponents/OIMobileTable.jsx